export default function PHP_trigger_error() {
  return (
    <div>
      <h1>PHP_trigger_error</h1>
    </div>
  );
}
